






































import { defineComponent, ref, nextTick, onUnmounted } from '@vue/composition-api';
import VirtualList from 'vue-virtual-scroll-list';
import ChatItem from './ChatItem.vue';
import NetworkRequest from 'common-module/src/components/NetworkRequest/index.vue';
import { useMessage } from '../hooks/useMessage';
import { useIntention } from '../hooks/useIntention';
import { useLocale } from '../hooks/useLocale';
import { useCustomMessage } from '../hooks/useCustomMessage';

export default defineComponent({
  components: {
    VirtualList,
    // eslint-disable-next-line vue/no-unused-components
    ChatItem,
    NetworkRequest
  },
  setup() {
    const { t } = useLocale();
    const { subscribeForIntent, subscribeForIntention } = useCustomMessage();
    const overflow = ref<boolean>(false);
    const isFirstPageReady = ref<boolean>(false);
    const { messages, loadMessage, subscribe, isEmpty, finished, loading } = useMessage();
    const { initIntention, subscribeForIntentBack, intentionBackSendMessage, clearIntentionBack } = useIntention();
    const scroller = ref<typeof VirtualList>();

    const scrollToBottom = () => nextTick(() => scroller.value?.scrollToBottom());
    const checkOverFlow = () => {
      if (scroller.value) {
        overflow.value = scroller.value.getScrollSize() > scroller.value.getClientSize();
      }
    };
    subscribeForIntent();
    subscribeForIntention();
    subscribeForIntentBack();
    subscribe(() => scrollToBottom());

    const onTop = async () => {
      if (finished.value || loading.value) {
        return;
      }
      const messages = await loadMessage(true);
      setTimeout(() => {
        scroller.value?.scrollToIndex(messages.length);
      }, 0);
    };

    onUnmounted(()=>{
      clearIntentionBack();
    });
    return {
      t,
      scroller,
      messages,
      isEmpty,
      finished,
      overflow,
      doRequest: async () => {
        const res = await loadMessage();
        if (res.length > 0) {
          intentionBackSendMessage();
          return;
        }
        if (loading.value) {
          return;
        }
        initIntention();
      },
      loadMessage,
      ChatItem,
      onTop,
      onItemRendered () {
        if (!scroller.value) {
          return;
        }

        // first page items are all mounted, scroll to bottom
        if (!isFirstPageReady.value && scroller.value.getSizes() >= messages.value.length) {
          isFirstPageReady.value = true;
          scrollToBottom();
        }

        checkOverFlow();
      }
    };
  }
});
